import { StyleSheet } from "react-native";
import React, { useEffect, FC, useContext } from "react";
import { View, Text } from "../../../components/Themed";
import Animated, {
  interpolate,
  useAnimatedStyle,
  useSharedValue,
  withSpring,
  withTiming,
} from "react-native-reanimated";
import GlobalContext from "../../../context/Global";

interface ErrorMessageProps {}

const ErrorMessage: FC<ErrorMessageProps> = ({}) => {
  const { error } = useContext(GlobalContext);
  const offset = useSharedValue(0);

  useEffect(() => {
    if (error) {
      offset.value = withSpring(1, { damping: 50, stiffness: 2000 });
    } else {
      offset.value = withTiming(0, { duration: 200 });
    }
  }, [error]);

  const animatedBodyStyle = useAnimatedStyle(() => {
    return {
      transform: [
        {
          scale: interpolate(offset.value, [0, 1], [0.6, 1]),
        },
      ],
      opacity: offset.value,
      marginBottom: interpolate(offset.value, [0, 1], [0, 70]),
    };
  });

  return (
    <View transparent style={styles.container}>
      <Animated.View style={[styles.body, animatedBodyStyle]}>
        <Text lightColor="#FA5D57" darkColor="#FA5D57">
          Invalid email and password combination.
        </Text>
      </Animated.View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    width: "100%",
    alignSelf: "center",
  },
  body: {
    backgroundColor: "#FAE6E6",
    marginHorizontal: 16,
    paddingHorizontal: 16,
    borderRadius: 4,
    borderWidth: 1,
    borderColor: "#FA5D57",
    justifyContent: "center",
    alignItems: "center",
    padding: 12,
    marginBottom: 20,
  },
  text: {
    color: "#FA5D57",
    fontSize: 12,
  },
});

export default ErrorMessage;
